// extracted by mini-css-extract-plugin
export default {"btn":"SearchResultRow_btn__1-C-z","table-number-cell":"SearchResultRow_table-number-cell__DO+cd","tr":"SearchResultRow_tr__4tb7A"};